export default __webpack_public_path__ + "static/media/Landing3.a57d2180.png";